import { debug as createDebug } from 'debug';
import { z } from 'zod';

import { ILogger } from './abstractions';
import { Logger } from './Logger';
import OneDsTelemetry from './OneDsTelemetry';

export const LoggingConfigSchema = z.object({
  baseNamespace: z.string().min(1),
});

export function composeLogging(config: z.infer<typeof LoggingConfigSchema>) {
  const debug = createDebug(config.baseNamespace);

  // TODO(nibeauli) Connect the debug library to sinks like ARIA
  const baseLogger: ILogger = new Logger({
    error: debug.extend('error'),
    trace: debug.extend('trace'),
    log: debug.extend('log'),
    warn: debug.extend('warn'),
  });
  OneDsTelemetry.initOneDs();

  return { baseLogger };
}
